import React from 'react';
import { Row as AntRow, Col as AntCol } from 'antd';

export const Row = props => {
  return <AntRow {...props} />;
};

export const Col = props => {
  return <AntCol {...props} />;
}